import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@els/els-react--text-input';

function PasswordField({ name, label, value = '', onChange, formErrors = [], onBlur, className }) {
  const [showPassword, setShowPassword] = useState(false);
  const [realValue, setRealValue] = useState(value);
  const inputRef = useRef(null);

  useEffect(() => {
    setRealValue(value);
  }, [value]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    // prevent copying password when it's hidden
    const handleCopy = (e) => {
      if (!showPassword) e.preventDefault();
    };
    const input = inputRef.current;
    if (input) {
      input.addEventListener('copy', handleCopy);
      return () => input.removeEventListener('copy', handleCopy);
    }
  }, [showPassword]);

  const handleInputChange = (e) => {
    const inputValue = e?.target?.value || '';
    setRealValue(inputValue);
    onChange({ ...e, target: { ...e.target, value: inputValue } });
  };

  const toggleShowPassword = () => setShowPassword((prev) => !prev);

  return (
    <TextInput
      key={name}
      id={name}
      name={name}
      label={label}
      className={className}
      value={realValue}
      data-e2e={`${name}-input`}
      onChange={handleInputChange}
      onBlur={onBlur}
      iconRight={{
        sprite: showPassword ? 'EyeNotVisible' : 'EyeVisible',
        children: showPassword ? 'hide password' : 'show password',
      }}
      iconRightCallback={toggleShowPassword}
      type={showPassword ? 'text' : 'password'}
      autoComplete="off"
      inputRef={inputRef}>
      {formErrors && (
        <>
          {formErrors.map((err, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <TextInput.Message key={`${label}-error-messages-${idx}`} id={`${label}-error-messages`} type="error">
              {err}
            </TextInput.Message>
          ))}
        </>
      )}
    </TextInput>
  );
}

PasswordField.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  formErrors: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
};

export default PasswordField;
